document.addEventListener("DOMContentLoaded", function () {

  const wrappers = document.querySelectorAll(".product-readmore");
  wrappers.forEach(function (wrapper) {
    const content = wrapper.querySelector(".readmore-content");
    const button = wrapper.querySelector(".readmore-toggle");

    if (content && button) {
      // Check if content overflows the collapsed height
      const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      const maxLines = 4; // must match -webkit-line-clamp
      const maxHeight = lineHeight * maxLines;

      if (content.scrollHeight <= maxHeight) {
        // content fits, hide the button
        button.style.display = "none";
      } else {
        // content overflows, enable read more toggle
        button.addEventListener("click", function () {
          content.classList.toggle("expanded");
          button.textContent = content.classList.contains("expanded") ? "Read Less" : "Read More";
        });
      }
    }

  });


  const toggle = document.querySelector(".toggle-password");
  const input = document.getElementById("CustomerPassword");
  if (toggle) {
    const eyeOn = toggle.querySelector(".password-eye-on");
    const eyeOff = toggle.querySelector(".password-eye-off");

    toggle.addEventListener("click", () => {
      if (input.type === "password") {
        input.type = "text";
        eyeOn.classList.remove('hidden');
        eyeOff.classList.add('hidden');
      } else {
        input.type = "password";
        eyeOn.classList.add('hidden');
        eyeOff.classList.remove('hidden');
      }
    });
  }

  const steps = document.querySelectorAll(".multi-step-form .form-step");
  const nextBtns = document.querySelectorAll(".multi-step-form .next-btn");
  const prevBtns = document.querySelectorAll(".multi-step-form .prev-btn");
  let currentStep = 0;

  function showStep(step) {
    steps.forEach((el, i) => el.classList.toggle("active", i === step));
  }

  nextBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      if (currentStep < steps.length - 1) {
        currentStep++;
        showStep(currentStep);
      }
    });
  });

  prevBtns.forEach(btn => {
    btn.addEventListener("click", () => {
      if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
      }
    });
  });

  showStep(currentStep);

  const previousSections = document.querySelectorAll('.inline-with-next-section');
  const nextSections = document.querySelectorAll('.inline-with-previous-section');

  previousSections.forEach((prev, i) => {
    const prevSection = prev.closest('.shopify-section');
    const nextSection = nextSections[i]?.closest('.shopify-section');

    // if(prevSection && nextSection) {
    //   const wrapper = document.createElement('div');
    //   wrapper.classList.add('pair-wrapper');
    //   wrapper.classList.add('page-width');

    //   prevSection.parentNode.insertBefore(wrapper, prevSection);
    //   wrapper.appendChild(prevSection);
    //   wrapper.appendChild(nextSection);
    // }

    if (prevSection && nextSection) {
      // Create the pair-wrapper div
      const wrapper = document.createElement('div');
      wrapper.classList.add('pair-wrapper');
      wrapper.classList.add('page-width');

      // Insert the wrapper before the first section
      prevSection.parentNode.insertBefore(wrapper, prevSection);

      // Move sections inside the wrapper
      wrapper.appendChild(prevSection);
      wrapper.appendChild(nextSection);

      // Use setTimeout to wait for content to load (e.g., icons-with-text)
      setTimeout(() => {
        const hasIconWithText = wrapper.querySelector('.icons-with-text');

        if (hasIconWithText) {
          // Create a new div for background
          const backgroundWrapper = document.createElement('div');
          backgroundWrapper.classList.add('background-wrapper');
          backgroundWrapper.style.background = '#eee'; // update style

          // Insert the new background div before the wrapper
          wrapper.parentNode.insertBefore(backgroundWrapper, wrapper);

          // Move the pair-wrapper inside the new background div
          backgroundWrapper.appendChild(wrapper);

        }
      }, 100); // adjust timeout if needed
    }

  })

  const faqLink = document.querySelector(".faq-link");
  if (faqLink) {
    faqLink.addEventListener("click", function (e) {
      e.preventDefault();
      // Select only the first FAQ section on this page
      const faqSection = document.querySelector(".section-collapsible-content");
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: "smooth" });
      }
    });
  }


  const productForm = document.querySelector('.sticky-product-form-container');
  const subscriptionWidget = document.querySelector('.selling_plan_container');
  if (window.innerWidth <= 768 && productForm && subscriptionWidget) {


    document.body.appendChild(productForm);

    // Mobile subscription handling
    const variantInputs = productForm.querySelectorAll('[name="id"]');

    function showSubscriptionForVariant(variantId) {
      subscriptionWidget.querySelectorAll('.selling_plan_theme_integration').forEach(section => {
        section.classList.toggle('selling_plan_theme_integration--hidden', section.dataset.variantId !== variantId);
      });

      // Auto-check subscription
      const visibleSection = subscriptionWidget.querySelector(`.selling_plan_theme_integration[data-variant-id="${variantId}"]`);
      const autoShipRadio = visibleSection?.querySelector('input[data-radio-type="selling_plan"]');
      if (autoShipRadio) {
        autoShipRadio.checked = true;
        autoShipRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    variantInputs.forEach(input => {
      input.addEventListener('change', (e) => showSubscriptionForVariant(e.target.value));
    });

    // Initialize first variant on mobile
    const initialVariantId = variantInputs[0]?.value;
    if (initialVariantId) showSubscriptionForVariant(initialVariantId);
  }

  if (document.querySelector('.purchase-options-container')) {
    const purchaseIcon = document.querySelector('.purchase-options-container');
    purchaseIcon.addEventListener("click", (e) => {

      const container = e.target.closest('.purchase-options');
      if (!container) return;
      const subscriptionWidget = container.querySelector('.purchase-option__container');
      const formButton = container.closest('.sticky-product-form-container')?.querySelector('.product-form__buttons');
      const iconCaret = container.querySelector('.icon-caret');

      if (!subscriptionWidget || !formButton) return;

      subscriptionWidget.classList.toggle('hidden');
      iconCaret?.classList.toggle('rotate');
      formButton.classList.toggle('hidden');
    })
  }


});

document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('.accordion-modal-trigger');
  const closeBtn = e.target.closest('.close-modal');
  const overlay = e.target.closest('.modal-overlay');

  if (openBtn) {
    const targetId = openBtn.dataset.modalTarget;
    const modal = document.getElementById(targetId);
    const mainContent = document.querySelector('#MainContent');


    if (modal && mainContent) {
      // Move modal inside MainContent (only if not already moved)
      if (modal.parentElement !== mainContent.parentElement) {
        mainContent.insertAdjacentElement('afterend', modal);
      }
      document.querySelectorAll('.accordion-modal-trigger.active').forEach(btn => btn.classList.remove('active'));
      openBtn.classList.add('active');
      modal.removeAttribute('hidden');
    }
  }

  if (closeBtn || overlay) {
    const modal = e.target.closest('.accordion-modal');
    if (modal) modal.setAttribute('hidden', '');
    document.querySelectorAll('.accordion-modal-trigger.active').forEach(btn => btn.classList.remove('active'));
  }
});